export default (to, from, next) => {
  if (
    to.params.tabId
    && (
      to.query.identifier
      || to.query.productFamily
    )
  ) next();
  else next({ path: `/${to.params.locale}/${to.params.path}/issue`, query: to.query });
};
